import { getSimpleDataSelector } from '@cp-shared-10/frontend-integration';
import { RootState } from 'store/rootReducer';

export const MyProfileDataSelector = getSimpleDataSelector((state: RootState) => state.myProfile);
